import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const TwitterX = ({ size = 24, style = {}, color = "currentColor" }: PropsType) => {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4525 3.33996C17.6423 3.12387 17.9161 3 18.2037 3H19.713C20.1431 3 20.3725 3.50698 20.0886 3.83005L14.6575 10.0105C14.3436 10.3678 14.3247 10.8968 14.6124 11.2756L21.3904 20.1975C21.6405 20.5268 21.4057 21 20.9922 21H16.3212C16.0105 21 15.7175 20.8556 15.5282 20.6092L11.7356 15.6721C11.3519 15.1725 10.6074 15.1479 10.1915 15.6211L5.76227 20.6602C5.57241 20.8762 5.29875 21 5.01117 21H3.49992C3.06984 21 2.84043 20.493 3.12432 20.17L9.01878 13.462C9.33405 13.1032 9.3516 12.5716 9.06066 12.1928L2.61796 3.80456C2.36537 3.4757 2.59983 3 3.01449 3H7.83212C8.14471 3 8.43932 3.14617 8.62841 3.39509L11.9576 7.77753C12.34 8.28096 13.0878 8.3076 13.5051 7.83266L17.4525 3.33996ZM16.6148 19.0941C16.6526 19.1434 16.7112 19.1723 16.7734 19.1723H17.9711C18.1365 19.1723 18.2304 18.983 18.1304 18.8513L7.46493 4.81071C7.42711 4.76093 7.36819 4.73169 7.30567 4.73169H5.98717C5.8213 4.73169 5.72752 4.92199 5.82857 5.05353L16.6148 19.0941Z"
        fill={color}
      />
    </svg>
  );
};

export default TwitterX;
